var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
// Utils
import { assert, getFrom, removeParentPath, isObjectOrArrayEmpty, isObject, joinPaths, shallowDifferences, getParentPath, } from 'ezyvet-fe-helpers';
import flatten from 'flat';
import equal from 'fast-deep-equal/es6';
import { getCommitted } from '../getCommitted';
import { getObjectId } from '../../objectIdentity';
import { constructChange } from './constructChange';
import { resolveNestedObjectsToObjectIds } from '../objectResolving';
import { addChangesForValue } from './addChangesForValue';
/**
 * For the given object, add to the the given changes any changes for the given object or nested
 * objects/arrays.
 *
 * @template T extends object
 * @param {T} values
 * @param {ChangeList} changes
 *
 * @return {void}
 */
export var addObjectPropertiesChanges = function (values, changes) {
    assert(isObject(values), 'Object required');
    var committedValue = getCommitted(values);
    if (values !== committedValue) {
        if (isObjectOrArrayEmpty(committedValue)) {
            // Then this is a new object, which has an accounting change already
            return;
        }
        var newValueResolved = resolveNestedObjectsToObjectIds(values);
        var committedValueResolved = resolveNestedObjectsToObjectIds(committedValue);
        // We don't flatten array changes as they are referenced directly to define their order.
        var newValueResolvedFlat_1 = flatten(newValueResolved, { safe: true });
        var committedValueResolvedFlat_1 = flatten(committedValueResolved, { safe: true });
        var _a = shallowDifferences(committedValueResolvedFlat_1, newValueResolvedFlat_1), deleted = _a.deleted, updated = _a.updated, added = _a.added, unchanged = _a.unchanged;
        var parentPath_1;
        var propertyName_1;
        var parent_1;
        var lastValue_1;
        var newValue_1;
        var objectId_1;
        deleted.forEach(function (path) {
            parentPath_1 = getParentPath(path);
            propertyName_1 = removeParentPath(path);
            parent_1 = getFrom(committedValue, parentPath_1);
            lastValue_1 = committedValueResolvedFlat_1[path];
            assert(isObject(parent_1), 'All changes must be relative to an object');
            objectId_1 = getObjectId(parent_1);
            changes[joinPaths(objectId_1, propertyName_1)] = constructChange(lastValue_1, undefined);
        });
        updated.filter(function (path) { return (
        // Filter out any that are not different
        !equal(committedValueResolvedFlat_1[path], newValueResolvedFlat_1[path])); }).forEach(function (path) {
            parentPath_1 = getParentPath(path);
            propertyName_1 = removeParentPath(path);
            parent_1 = getFrom(committedValue, parentPath_1);
            lastValue_1 = committedValueResolvedFlat_1[path];
            newValue_1 = newValueResolvedFlat_1[path];
            assert(isObject(parent_1), 'All changes must be relative to an object');
            objectId_1 = getObjectId(parent_1);
            changes[joinPaths(objectId_1, propertyName_1)] = constructChange(lastValue_1, newValue_1);
        });
        added.forEach(function (path) {
            parentPath_1 = getParentPath(path);
            propertyName_1 = removeParentPath(path);
            parent_1 = getFrom(committedValue, parentPath_1);
            newValue_1 = newValueResolvedFlat_1[path];
            lastValue_1 = undefined;
            assert(isObject(parent_1), 'All changes must be relative to an object');
            objectId_1 = getObjectId(parent_1);
            changes[joinPaths(objectId_1, propertyName_1)] = constructChange(lastValue_1, newValue_1);
        });
        __spreadArray(__spreadArray([], updated), unchanged).forEach(function (path) {
            newValue_1 = getFrom(values, path);
            if (Array.isArray(newValue_1)
                || isObject(newValue_1)) {
                addChangesForValue(values, path, changes);
            }
        });
    }
};
//# sourceMappingURL=addObjectPropertiesChanges.js.map